import React from 'react'

import './css/Footer.css'
import FooterText from './text/footer-text'

export default class Footer extends React.Component {
  render() {
    return (
      <div className="footer-container">
        <div className="footer-text">{FooterText[0]}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/Footer.js